import Index from "./contactcomponents/map"
import ContactForm from "./contactcomponents/contactform"
import Header from "./header"
import Footer from "./footer"
import contactusimaes from '../images/contactusimage.jpg'
function Contact (){
    return(<>

<style>
  {`
    /* Base styles for large screens */
    .cardbannerimage {
      width: 100%;
      height: 75vh; /* Set height for large screens */
      object-fit: 100% 100%; /* Ensures image fills the container while maintaining aspect ratio */
    }

    /* Adjustments for small screens */
    @media (max-width: 768px) {
      .cardbannerimage {
        height: 40vh; /* Set reduced height for small devices */
        object-fit: contain; /* Ensures the entire image is visible without cropping */
      }
    }
  `}
</style>
     <Header/>

     <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-12 p-0 cardbanner">
            <img src={contactusimaes} className="w-100 cardbannerimage"
            />
          </div>
        </div>
      </div>
      <ContactForm/>
      <Index/>
      <Footer/>
    
    </>)
}
export default Contact